<template>

  <div style="background: #f2f2f6; height: 100%">
    <el-form size="mini" label-width="100px" class="demo-form-inline">

       <el-form-item :label="$t('base.timeInterval')">
           <el-date-picker
      v-model="value1"
    type="datetimerange"
    :range-separator="$t('base.to')"
    :start-placeholder="$t('base.beginTime')"
    size="mini"
    value-format="yyyy-MM-dd HH:mm:ss"
    :default-time="['00:00:00','23:59:59']"
    :end-placeholder="$t('base.endTime')">
  </el-date-picker>
     <el-button size="small" type="primary"  @click="search()">{{$t("base.search")}}</el-button>
  </el-form-item>
    </el-form>

    <el-row style="padding:0 10px">
      <el-col  v-loading="loading"  element-loading-background="rgba(255, 255, 255, 0.8)"  :span='24' style="height:370px;">
        <div id="simDiv" style="width:100%;height:370px">
      </div>
      </el-col>
    </el-row>
  </div>


</template>

<script>
import Vue from 'vue'
let chartToge=null
export default {
  name: 'Report',
  data () {
    return {
      value1: [],
      loading: false
    }
  },
  computed: {

  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
       let yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 7)
        this.value1 = [yesterday.Format('yyyy-MM-dd HH:mm:00'), (new Date()).Format('yyyy-MM-dd HH:mm:00')]
        chartToge=null
        this.search()
        setTimeout(()=>{
          chartToge.resize()
        },4000)
    } else {
      this.$router.push({ name: 'Login' })
    }
         
  },
  methods: {
    search: function () {
      if (this.value1 && this.value1.length == 2) {
        var self = this
        this.loading = true
        Vue.axios
          .post('/sim/report/query', {startdate: this.value1[0], enddate: this.value1[1], equipmentid: this.$route.params.equipmentid })
          .then((res) => {
            if (res.data.errcode == 0) {
              if(!chartToge){
                chartToge=self.$echarts.init(document.getElementById('simDiv'), 'shine')
              }
              chartToge.setOption(buildTogOption(res.data.msgbody),true)
              chartToge.resize()
              self.loading = false
            }
          })
      } else {
        this.$message({
          message: this.$t('base.requireTimeInterval'),
          type: 'warning'
        })
      }
    }
  }
}

function buildTogOption(data){

  let series = [{
      name: '当日流量',
    type: 'line',
    data:data.y,
    smooth: false,
    showSymbol: true
    },{
      name: '总消耗',
    type: 'line',
    data:data.y1,
    smooth: false,
    showSymbol: true,
    yAxisIndex :1
    }]
  let legendData=['当日流量','总消耗']

  return {
    title: {
      show: false
    },
    //color: ['#73c0de'],
    grid: {
      left: '5%',
      top: '10%',
      right: '5%',
      bottom: '20%'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      show: true,
      type:'scroll',
      data: legendData,
      bottom:0
    },
    xAxis: {
      type: 'category',
      axisLine: { show: true, lineStyle: { color: '#dddddd' } },
      axisLabel: {
        color: '#929292'
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dotted',
          color: '#dddddd'
        }

      },
      splitNumber: 10,
      boundaryGap: false,
      data: data.x
    },
    yAxis: [{
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          color: '#dddddd'
        }
      },
      axisLine: { show: true, lineStyle: { color: '#dddddd' } },
      axisLabel: {
        formatter: '{value}MB',
        color: '#929292'
      },
      axisTick: { length: 0 }
    },{
      type: 'value',
      splitLine: {
        show: false,
        lineStyle: {
          color: '#dddddd'
        }
      },
      axisLine: { show: true, lineStyle: { color: '#dddddd' } },
      axisLabel: {
        formatter: '{value}MB',
        color: '#929292'
      },
      axisTick: { length: 0 }
    }],
    series: series

  }
}


Date.prototype.Format = function (formatStr) {
  var str = formatStr
  var Week = ['日', '一', '二', '三', '四', '五', '六']

  str = str.replace(/yyyy|YYYY/, this.getFullYear())
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : '0' + (this.getYear() % 100)
  )

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1)
  )
  str = str.replace(/M/g, this.getMonth())

  str = str.replace(/w|W/g, Week[this.getDay()])

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate()
  )
  str = str.replace(/d|D/g, this.getDate())

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours()
  )
  str = str.replace(/h|H/g, this.getHours())
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : '0' + this.getMinutes()
  )
  str = str.replace(/m/g, this.getMinutes())

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : '0' + this.getSeconds()
  )
  str = str.replace(/s|S/g, this.getSeconds())

  return str
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .popperClass {
    width: 12.5rem /* 200/16 */;
  }
</style>
<style>
.el-switch__label *{
  font-size: 12px;
}</style>


// WEBPACK FOOTER //
// src/components/Devices/Adv.vue